import React, { Component } from "react";
import PropTypes from "prop-types";

export const STICKYTYPES = {
  DYNAMICTOP: "dynamicTop",
  DYNAMICBOTTOM: "dynamicBottom",
  STATICTOP: "staticTop",
  STATICBOTTOM: "staticBottom",
};

export const POSITION = {
  DYNAMIC: "DYNAMIC",
  STATIC: "STATIC",
};

let ACCURACY = 60;

export const BEHAVIOUR = {
  ALL_STICKY: "ALL_STICKY",
  STATIC_TOP: "STATIC_TOP",
};

function toggleBetween(el, classA, classB) {
  if (el.classList.contains(classA)) {
    el.classList.replace(classA, classB);
  } else {
    el.classList.replace(classB, classA);
  }
}

class Sticky extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shadow: false,
      fixed: true,
      height: undefined,
      elem: undefined,
    };
  }

  componentDidMount() {
    this.setState(this.getFixed());
    window.addEventListener("scroll", this.scrollHandler, false);
  }

  componentWillUnmount() {
    try {
      window.removeEventListener("scroll", this.handleScroll);
    } catch {
      console.error("handleScroll is not defined");
    }
  }

  changeDomClassNames(){
    const { fixed } = this.state;
    switch (fixed) {
      case true:
        document.body.style.paddingTop = `${this.state.height}px`;
        ACCURACY = this.state.height;
        toggleBetween(this.state.elem, 'static', 'fixed');
        break;

      case false:
        document.body.style.paddingTop = `0px`;
        toggleBetween(this.state.elem, 'fixed', 'static');
        break;
    }
  }

  componentDidUpdate() {
    this.getFixed();
  }

  // FUNCTIONS
  getFixed = () => {
    const elem = document.querySelector(".Sticky");
    if (!elem && !this.state.elem) return undefined;

    const { height } = elem.getBoundingClientRect();
    const scrollY = window.scrollY;
    const diff = scrollY - 0;
    const amount = Math.abs(diff);
    
    switch (this.props.behaviour) {
      case "ALL_STICKY":
        return { 
          fixed: scrollY >= 0, 
          height: height, 
          elem: elem,
          shadow: amount > ACCURACY
        };

      default:
        return { 
          fixed: scrollY > height, 
          height: height, 
          elem: elem ,
          shadow: amount > ACCURACY
        };
    }
  };

  scrollHandler = () => {
    const newFixed = this.getFixed();

    if (
      newFixed && 
      (this.state.fixed !== newFixed.fixed || this.state.shadow !== newFixed.shadow)
    ) {
      this.setState(newFixed, () => {
        this.changeDomClassNames();
      });
    }
  };

  render() {
    const { shadow } = this.state;
    const stickyClass = `Sticky static ${this.props.className} ${shadow ? 'shadow' : ''}`;

    return (
      <>
        <div className={stickyClass}>{this.props.children}</div>
        <style jsx>{`.Sticky {
  width: 100vw;
  z-index: 50;
  background-color: white;
  transition: all 0.3s;
  &.static {
    position: static;
    top: 0px;
  }
  &.fixed{
    position:fixed;
    top:0px
  }
  &.shadow {
    transition: all 0.3s;
    box-shadow: 0px 0px 5px 0px rgba(49,50,53,0.75);
    -webkit-box-shadow: 0px 0px 5px 0px rgba(49,50,53,0.75);
    -moz-box-shadow: 0px 0px 5px 0px rgba(49,50,53,0.75);
  }
}
`}</style>
      </>
    );
  }
}

Sticky.propTypes = {};

Sticky.defaultProps = {
  type: STICKYTYPES.DYNAMICTOP,
  className: "",
  position: POSITION.DYNAMIC,
  behaviour: BEHAVIOUR.STICK_TO_TOP,
};

export default Sticky;
